import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ConversationService} from '../../../service/chat/conversation.service';
import {User} from '../../../../core/domain/user';
import {Conversation} from '../../../domain/conversation';
import * as moment from 'moment/moment'
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../../../../core/service/user.service';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/of';
import {AuthService} from '../../../../core/security/auth.service';
import { ProfileService } from 'app/profile/service/profile.service';
import { asElementData } from '@angular/core/src/view';
import { loadavg } from 'os';
import { ConfirmationService } from "primeng/primeng";
import { GlobalAppService } from "../../../../core/commons/global-app.service";
import { MessageSeverity } from "../../../../core/commons/message-severity";



@Component({
    selector: 'conversation-list',
    templateUrl: './conversation-list.component.html',
    styleUrls: ['./conversation-list.component.scss'],
    providers: [UserService, ProfileService],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationListComponent implements OnInit, OnDestroy {

    user: User = null;
    conversations: Conversation[] = [];
    @Output('conversationSelected')
    conversationOutput: EventEmitter<Conversation> = new EventEmitter();
    page = 0;
    pageSize = 10;
    public userList: User[] = [];
    public userSearch: Subject<string> = new Subject();
    public isSearch = false;

    constructor(private conversationService: ConversationService,
                private userService: UserService,
                private authService: AuthService,
                private profileService: ProfileService,
                private confirmationService: ConfirmationService,
                private appService: GlobalAppService
                // private cd: ChangeDetectorRef
    ) {
        moment.locale('es');
    }

    ngOnInit() {
        this.conversationService.unsetSelectedConversation();
        this.conversationService.subscribeConversationList()
            .subscribe(c => {
                this.conversations = c;
                this.loadProfilePhotos();
                // this.cd.markForCheck();
            });
        this.conversationService.getConversationList();

        this.userSearch.asObservable()
            .debounceTime(300)
            .distinctUntilChanged()
            .do( term => this.isSearch = true )
            .switchMap( term => {
                this.conversations = this.conversationService.filterConversations( term );
                this.loadProfilePhotos();
                if (term !== '') {
                    return this.userService.findByValue(term)
                        .map(users => users.filter(user => user.id !== this.authService.user_value.id));
                }
                this.isSearch = false;
                return Observable.of([]);
            } )
            .catch( error => Observable.of([]) )
            .subscribe(u => {
                this.userList = u;
                this.userList.forEach(user => {
                    this.profileService.getProfilePhotoByUserId(user.id)
                    .subscribe(profile => {
                        user.profilePhoto = profile.profilePhoto;
                    })
                })
                // this.cd.markForCheck();
            });
    }

    ngOnDestroy() {
        this.conversationService.unsetSelectedConversation();
    }

    public search(val: string): void {
        this.userSearch.next(val);
    }

    loadProfilePhotos() {
        this.conversations.forEach(c => {
            this.profileService.getProfilePhotoByUserId(c.participants[0].id)
                    .subscribe(profile => {
                        c.participants[0].profilePhoto = profile.profilePhoto;
                    })
        });
    }

    public getConversation(c: Conversation) {
        c = new Conversation(c)
        this.conversationService.setSelectedConversation(c);
        this.conversationOutput.emit(c);
        // this.cd.markForCheck();
    }

    public getCreateTime(time: number): string {
        return moment(time, 'x').fromNow()
    }

    public createConversation( participant: User ): void {
        const c: Conversation = new Conversation();
        c.participants = [];
        c.participants.push(participant);
        c.participants.push(this.conversationService.user);
        c.groupConversation = false;
        c.createTime = new Date().getTime();
        this.conversationOutput.emit(c);
    }

    public deleteConversation(conversation: Conversation):void {
        this.confirmationService.confirm({
          message: "¿está seguro que desea eliminar la conversación?",
          icon: "fa ui-icon-delete-forever",
          accept: () => {
            this.appService.setLoading(true);
            this.conversationService.delete(conversation).subscribe(
              b => {
                this.appService.setLoading(false);
                this.applyFilter();
                this.appService.sendMsg(
                  MessageSeverity.SUCCESS,
                  "Eliminado",
                  "Se ha eliminado la conversación."
                );
              },
              error => {
                this.appService.setLoading(false);
                this.appService.sendMsg(
                  MessageSeverity.ERROR,
                  "Error",
                  "No ha sido posible eliminar la conversación. " +
                    error.json().message
                );
              }
            );
          }
        });
      }

      applyFilter() {
      }
      

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/chat/conversation-list/conversation-list.component.ts